export default __webpack_public_path__ + "static/media/search.13f93321.svg";